// LoadingContext.tsx
import React, {
    createContext,
    useContext,
    useState,
    Dispatch,
    SetStateAction,
  } from 'react';
  
  type LoadingContextType = {
    isLoading: boolean;
    setIsLoading: Dispatch<SetStateAction<boolean>>;
  };
  
  // Provide initial dummy values with correct types
  const LoadingContext = createContext<LoadingContextType>({
    isLoading: false,
    setIsLoading: () => {
      throw new Error('setIsLoading must be used within LoadingProvider');
    },
  });
  
  export const LoadingProvider = ({ children }: { children: React.ReactNode }) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
  
    return (
      <LoadingContext.Provider value={{ isLoading, setIsLoading }}>
        {children}
      </LoadingContext.Provider>
    );
  };
  
  export const useLoading = () => useContext(LoadingContext);
  